<div class="flex justify-content-center">
  <div class="flex-column mt-3" style="width: 100%; max-width: 1400px;">
    <!-- Store Information Header (Always Visible) -->
    <div class="store-header-container" (click)="toggleStorePanel()">
      <div class="store-header">
        <div class="store-header-content">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          <span class="store-name">{{storeInfo.get('storeDataName')?.value || storeData?.name || 'Loading...'}}</span>
          @if (storeInfo.get('storeDataCity')?.value || storeData?.location) {
            <span class="store-location">{{storeInfo.get('storeDataCity')?.value || storeData?.location}}</span>
          }
        </div>
        <button mat-icon-button class="expand-icon">
          <mat-icon>{{storePanelExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>
      </div>
    </div>

    <!-- Store Information Panel (Collapsible) -->
    @if (storePanelExpanded) {
      <mat-card class="store-info-card">
        <mat-card-content>
          <form [formGroup]="storeInfo">
            <div class="store-info-grid">
              <div class="info-item">
                <label class="info-label">Email</label>
                <input type="email" formControlName="storeDataEmail" class="info-input" [readonly]="!canEditStoreInfo" [class.readonly]="!canEditStoreInfo">
              </div>
              <div class="info-item">
                <label class="info-label">Phone</label>
                <input type="tel" formControlName="storeDataPhone" class="info-input" [readonly]="!canEditStoreInfo" [class.readonly]="!canEditStoreInfo">
              </div>
              <div class="info-item full-width">
                <label class="info-label">Address</label>
                <input type="text" formControlName="storeDataAddress" class="info-input" [readonly]="!canEditStoreInfo" [class.readonly]="!canEditStoreInfo">
              </div>
              <div class="info-item">
                <label class="info-label">City</label>
                <input type="text" formControlName="storeDataCity" class="info-input" [readonly]="!canEditStoreInfo" [class.readonly]="!canEditStoreInfo">
              </div>
              <div class="info-item full-width">
                <label class="info-label">Description</label>
                <textarea formControlName="storeDescription" class="info-textarea" [readonly]="!canEditStoreInfo" [class.readonly]="!canEditStoreInfo"></textarea>
              </div>
            </div>
            <div class="store-actions">
              @if (!canEditStoreInfo) {
                <button mat-raised-button color="primary" (click)="editStoreInfo()">
                  <mat-icon>edit</mat-icon> Edit Store Info
                </button>
              }
              @if (canEditStoreInfo) {
                <button mat-raised-button color="primary" (click)="saveStoreInfo()">
                  <mat-icon>save</mat-icon> Save Changes
                </button>
                <button mat-button (click)="cancelEditStoreInfo()">
                  <mat-icon>cancel</mat-icon> Cancel
                </button>
              }
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    }
    <!-- Activity Creation Stepper -->
    <mat-card class="activity-creation-card">
      <mat-card-header>
        <mat-card-title>{{editingActivityId ? 'Edit Activity' : 'Create New Activity'}}</mat-card-title>
        @if (editingActivityId) {
          <button mat-icon-button (click)="resetActivityCreation(); createActivity = false" style="margin-left: auto;">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-card-header>
      <mat-card-content>
        <mat-stepper #stepper="matStepper" [linear]="true">
          <!-- Step 1: Describe the Activity -->
          <mat-step [stepControl]="createNewActivityAbout">
            <ng-template matStepLabel>Activity Details</ng-template>
            <form [formGroup]="createNewActivityAbout" class="sleek-form">
              <div class="form-section">
                <h3 class="section-title">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                  Activity Information
                </h3>
                
                <div class="form-grid">
                  <div class="form-field">
                    <label>Activity Name <span class="required">*</span></label>
                    <input type="text" formControlName="activityName" 
                           class="form-input"
                           [class.invalid]="createNewActivityAbout.get('activityName')?.invalid && createNewActivityAbout.get('activityName')?.touched"
                           placeholder="Enter activity name">
                    <span class="error-message" *ngIf="createNewActivityAbout.get('activityName')?.invalid && createNewActivityAbout.get('activityName')?.touched">
                      Activity name is required
                    </span>
                  </div>

                  <div class="form-field">
                    <label>Main Activity Type <span class="required">*</span></label>
                    <select formControlName="mainActivityType" 
                            class="form-input"
                            [class.invalid]="createNewActivityAbout.get('mainActivityType')?.invalid && createNewActivityAbout.get('mainActivityType')?.touched">
                      <option value="">Select activity type</option>
                      @for (option of mainActivityOptions; track option) {
                        <option [value]="option">{{option}}</option>
                      }
                    </select>
                    <span class="error-message" *ngIf="createNewActivityAbout.get('mainActivityType')?.invalid && createNewActivityAbout.get('mainActivityType')?.touched">
                      Activity type is required
                    </span>
                  </div>

                  <div class="form-field full-width">
                    <label>Activity Summary <span class="required">*</span></label>
                    <input type="text" formControlName="activityDescription"
                           class="form-input"
                           [class.invalid]="createNewActivityAbout.get('activityDescription')?.invalid && createNewActivityAbout.get('activityDescription')?.touched"
                           placeholder="Brief description of the activity">
                    <span class="error-message" *ngIf="createNewActivityAbout.get('activityDescription')?.invalid && createNewActivityAbout.get('activityDescription')?.touched">
                      Activity summary is required
                    </span>
                  </div>

                  <div class="form-field full-width">
                    <label>Full Description</label>
                    <textarea formControlName="activityFullDescription"
                              class="form-input form-textarea"
                              rows="4"
                              placeholder="Detailed description of the activity..."></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div class="stepper-actions">
              <button mat-raised-button color="primary" matStepperNext [disabled]="createNewActivityAbout.invalid">Next</button>
            </div>
          </mat-step>

          <!-- Step 2: Settings and Pricing (Activity Creation) -->
          <mat-step [stepControl]="createNewActivitySettings" [optional]="false">
            <ng-template matStepLabel>Settings & Pricing</ng-template>
            <form [formGroup]="createNewActivitySettings" class="sleek-form">
              <div class="form-section">
                <h3 class="section-title">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                  Pricing & Settings
                </h3>
                
                <div class="form-grid">
                  <div class="form-field">
                    <label>Price Per Person <span class="required">*</span></label>
                    <input type="number" formControlName="pricePerPerson"
                           class="form-input"
                           [class.invalid]="createNewActivitySettings.get('pricePerPerson')?.invalid && createNewActivitySettings.get('pricePerPerson')?.touched"
                           placeholder="0.00"
                           min="0"
                           step="0.01">
                    <span class="error-message" *ngIf="createNewActivitySettings.get('pricePerPerson')?.invalid && createNewActivitySettings.get('pricePerPerson')?.touched">
                      Price per person is required
                    </span>
                  </div>

                  <div class="form-field">
                    <label>Discount %</label>
                    <input type="number" formControlName="discountPricePercentage"
                           class="form-input"
                           placeholder="0"
                           min="0"
                           max="100"
                           step="1">
                  </div>

                  <div class="form-field">
                    <label>Currency <span class="required">*</span></label>
                    <select formControlName="currencyCtrl"
                            class="form-input"
                            [class.invalid]="createNewActivitySettings.get('currencyCtrl')?.invalid && createNewActivitySettings.get('currencyCtrl')?.touched">
                      <option value="">Select currency</option>
                      @for (currency of currencyOptions; track currency.value) {
                        <option [value]="currency.value">{{currency.label}}</option>
                      }
                    </select>
                    <span class="error-message" *ngIf="createNewActivitySettings.get('currencyCtrl')?.invalid && createNewActivitySettings.get('currencyCtrl')?.touched">
                      Currency is required
                    </span>
                  </div>

                  <div class="form-field">
                    <label>Duration <span class="required">*</span></label>
                    <select formControlName="durationCtrl"
                            class="form-input"
                            [class.invalid]="createNewActivitySettings.get('durationCtrl')?.invalid && createNewActivitySettings.get('durationCtrl')?.touched">
                      <option value="">Select duration</option>
                      @for (duration of durationOptions; track duration) {
                        <option [value]="duration">{{duration}}</option>
                      }
                    </select>
                    <span class="error-message" *ngIf="createNewActivitySettings.get('durationCtrl')?.invalid && createNewActivitySettings.get('durationCtrl')?.touched">
                      Duration is required
                    </span>
                  </div>

                  <div class="form-field">
                    <label>Language <span class="required">*</span></label>
                    <select formControlName="languageCtrl"
                            class="form-input"
                            [class.invalid]="createNewActivitySettings.get('languageCtrl')?.invalid && createNewActivitySettings.get('languageCtrl')?.touched">
                      <option value="">Select language</option>
                      @for (language of languageOptions; track language) {
                        <option [value]="language">{{language}}</option>
                      }
                    </select>
                    <span class="error-message" *ngIf="createNewActivitySettings.get('languageCtrl')?.invalid && createNewActivitySettings.get('languageCtrl')?.touched">
                      Language is required
                    </span>
                  </div>

                  <div class="form-field full-width">
                    <div style="display: flex; gap: 24px; align-items: center;">
                      <label style="display: flex; align-items: center; gap: 8px; margin: 0; cursor: pointer;">
                        <input type="checkbox" formControlName="topPickCtrl" style="width: 18px; height: 18px; cursor: pointer;">
                        <span>Top Pick</span>
                      </label>
                      <label style="display: flex; align-items: center; gap: 8px; margin: 0; cursor: pointer;">
                        <input type="checkbox" formControlName="sellOutCtrl" style="width: 18px; height: 18px; cursor: pointer;">
                        <span>Potential Sell Out</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="stepper-actions">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-raised-button color="primary" (click)="onSettingsStepCompleted()" [disabled]="createNewActivitySettings.invalid">
                {{editingActivityId ? 'Update Activity' : 'Create Activity'}}
              </button>
            </div>
          </mat-step>

          <!-- Step 3: Activity Dates and Availability -->
          <mat-step [stepControl]="createNewActivityTimeDates">
            <ng-template matStepLabel>Dates & Availability</ng-template>
            @if (!activityId) {
              <p class="error-message">Please complete the previous step to create the activity first.</p>
            }
            @if (activityId) {
            <form [formGroup]="createNewActivityTimeDates" class="sleek-form">
              <div class="form-section">
                <h3 class="section-title">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  Date Selection & Availability
                </h3>
                
                <div class="date-mode-toggle" role="group" aria-label="Date selection mode">
                  <button type="button"
                          class="mode-button"
                          [class.active]="dateMode === 'single'"
                          (click)="setDateMode('single')">
                    Single Date
                  </button>
                  <button type="button"
                          class="mode-button"
                          [class.active]="dateMode === 'bulk'"
                          (click)="setDateMode('bulk')">
                    Date Range
                  </button>
                </div>
                
                <div class="form-grid" style="margin-top: 20px;">
                  <div class="form-field" style="grid-column: 1 / -1;">
                    <label>Select Dates</label>
                    <div class="flex" style="gap: 24px; flex-wrap: wrap;">
                      <div style="min-width: 300px;">
                        <!-- Single date selection mode -->
                        @if (dateMode === 'single') {
                          <mat-calendar [(selected)]="dateSelected"></mat-calendar>
                        }
                        
                        <!-- Bulk date selection mode -->
                        @if (dateMode === 'bulk') {
                          <div class="flex" style="gap: 24px; flex-wrap: wrap;">
                            <div style="flex: 1; min-width: 280px;">
                              <h6 style="margin-bottom: 8px; font-size: 0.9rem; font-weight: 600; color: #2d3748;">Start Date</h6>
                              <mat-calendar [(selected)]="dateRangeStart"></mat-calendar>
                            </div>
                            <div style="flex: 1; min-width: 280px;">
                              <h6 style="margin-bottom: 8px; font-size: 0.9rem; font-weight: 600; color: #2d3748;">End Date</h6>
                              <mat-calendar [(selected)]="dateRangeEnd"></mat-calendar>
                            </div>
                          </div>
                          @if (dateRangeStart && dateRangeEnd) {
                            <p style="margin-top: 16px; color: #667eea; font-weight: 600; text-align: center;">
                              {{getDateRange().length}} dates selected
                            </p>
                          }
                        }
                      </div>
                      <div style="flex: 1; min-width: 200px;">
                        <label style="display: block; margin-bottom: 8px; font-size: 0.9rem; font-weight: 600; color: #2d3748;">Selected Dates</label>
                        <div style="background: #f7fafc; border: 2px solid #e2e8f0; border-radius: 8px; padding: 12px; max-height: 400px; overflow-y: auto;">
                          @if (availability.length === 0) {
                            <p style="color: #718096; margin: 0;">No dates added yet</p>
                          }
                          @for (item of availability; track item.dateFormated) {
                            <div style="padding: 8px; border-bottom: 1px solid #e2e8f0;">
                              <span style="color: #2d3748; font-weight: 500;">{{item.dateFormated}}</span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-section">
                <h3 class="section-title">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  Time Slots
                </h3>
                
                <div class="slot-grid">
                  <div class="slot-card">
                    <div class="form-field">
                      <label>Slot 1 Label</label>
                      <input type="text"
                             formControlName="timeSlotLabel1"
                             class="form-input"
                             placeholder="Morning: 8 AM-12 PM">
                    </div>
                    <div class="form-field">
                      <label>Capacity</label>
                      <input type="number"
                             formControlName="numberOfSlots1"
                             class="form-input"
                             placeholder="0"
                             min="0">
                    </div>
                  </div>

                  <div class="slot-card">
                    <div class="form-field">
                      <label>Slot 2 Label</label>
                      <input type="text"
                             formControlName="timeSlotLabel2"
                             class="form-input"
                             placeholder="Afternoon: 12 PM-5 PM">
                    </div>
                    <div class="form-field">
                      <label>Capacity</label>
                      <input type="number"
                             formControlName="numberOfSlots2"
                             class="form-input"
                             placeholder="0"
                             min="0">
                    </div>
                  </div>

                  <div class="slot-card">
                    <div class="form-field">
                      <label>Slot 3 Label</label>
                      <input type="text"
                             formControlName="timeSlotLabel3"
                             class="form-input"
                             placeholder="Evening: 5 PM-12 AM">
                    </div>
                    <div class="form-field">
                      <label>Capacity</label>
                      <input type="number"
                             formControlName="numberOfSlots3"
                             class="form-input"
                             placeholder="0"
                             min="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-actions">
                <button type="button" class="btn btn-primary" (click)="saveBookingDateTime()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
                    <polyline points="17 21 17 13 7 13 7 21"></polyline>
                    <polyline points="7 3 7 8 15 8"></polyline>
                  </svg>
                  Add Booking Date and Time
                </button>
              </div>
            </form>
            }
            <div class="stepper-actions">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-raised-button color="primary" matStepperNext [disabled]="!activityId || createNewActivityTimeDates.invalid || availability.length === 0">Next</button>
            </div>
          </mat-step>

          <!-- Step 4: Activity Pictures -->
          <mat-step [optional]="true">
            <ng-template matStepLabel>Pictures</ng-template>
            <form [formGroup]="createNewActivityPictures">
              @if (!activityId) {
                <p class="error-message">Please complete the previous steps first to create the activity.</p>
              }
              @if (activityId) {
                    <div class="flex">
                      <div class="container w-50" appDraganddrop (fileDropped)="onFileDropped($any($event))">
                        <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($any($event.target).files)" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
                          <g fill="#3B454F" fill-rule="nonzero">
                            <path
                              d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
                              <path
                                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
                                <path
                                  d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
                                </g>
                              </svg>

                              <h3>Drag and drop file here</h3>
                              <h3>or</h3>
                              <label for="fileDropRef">Browse for file</label>
                            </div>
                            <div class="files-list w-50">
                              @for (file of files; track file; let i = $index) {
                                <div class="single-file">
                                  <div class="file-icon" style="width: 50px">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px" y="0px" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
                                      <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
                                      <g>
                                        <path style="fill:#CEC9AE;"
                                          d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
                                          <path style="fill:#CEC9AE;"
                                            d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
                                            <path style="fill:#CEC9AE;"
                                              d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
                                              <path style="fill:#CEC9AE;"
                                                d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
                                                <path style="fill:#CEC9AE;"
                                                  d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
                                                </g>
                                                <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
                                              </svg>
                                            </div>
                                            <div class="info">
                                              <h4 class="name">
                                                {{ file?.name }}
                                              </h4>
                                              <p class="size">
                                                {{ formatBytes(file?.size) }}
                                              </p>
                                              <app-progress [progress]="file?.progress"></app-progress>
                                            </div>
                                            <div class="delete" (click)="deleteFile(i)">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                                                <path fill="#B1B1B1" fill-rule="nonzero"
                                                  d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
                                                </svg>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      </div>
                <div class="flex justifyContentCenter mt-3">
                  <button mat-raised-button (click)="addPictures(activityId)" [disabled]="!activityId">Add Pictures</button>
                </div>
              }
            </form>
            <div class="stepper-actions">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-raised-button color="primary" (click)="onPicturesStepCompleted()" [disabled]="!activityId">
                Complete
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </mat-card-content>
    </mat-card>
                            <mat-card class="activity-display mt-3 me-3">
                              <mat-card-header>
                                <div class="activity-header-actions">
                                  <h2>Activities</h2>
                                  <button mat-raised-button color="primary" (click)="navigateToArchive()">
                                    <mat-icon>archive</mat-icon>
                                    View Archive
                                  </button>
                                </div>
                              </mat-card-header>
                              <mat-card-content>
                                @if (storeActivities.length > 0) {
                                  <table mat-table [dataSource]="storeActivities">
                                    <ng-container matColumnDef="activity-name">
                                      <th mat-header-cell *matHeaderCellDef>Activity Name</th>
                                      <td mat-cell *matCellDef="let activity">{{activity.name}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="activity-mainActivityType">
                                      <th mat-header-cell *matHeaderCellDef>Activity Type</th>
                                      <td mat-cell *matCellDef="let activity">{{activity.mainActivityType}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="activity-description">
                                      <th mat-header-cell *matHeaderCellDef>Activity Description</th>
                                      <td mat-cell *matCellDef="let activity">{{activity.description}}</td>
                                    </ng-container>
                                    <ng-container matColumnDef="activity-view-page">
                                      <th mat-header-cell *matHeaderCellDef>View Activity Page</th>
                                      <td mat-cell *matCellDef="let activity"><div (click)="onClickGo(activity.id)" >View Activity Page</div></td>
                                    </ng-container>
                                    <ng-container matColumnDef="activity-actions">
                                      <th mat-header-cell *matHeaderCellDef>Actions</th>
                                      <td mat-cell *matCellDef="let activity">
                                        <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                                          <button mat-raised-button color="primary" (click)="editActivity(activity)" class="action-button">
                                            <mat-icon>edit</mat-icon>
                                            Edit
                                          </button>
                                          <button mat-raised-button color="warn" (click)="archiveActivity(activity.id)" class="action-button">
                                            <mat-icon>archive</mat-icon>
                                            Archive
                                          </button>
                                          <button mat-raised-button color="warn" (click)="deleteActivity(activity.id, activity.name)" class="action-button" style="background-color: #d32f2f;">
                                            <mat-icon>delete_forever</mat-icon>
                                            Delete
                                          </button>
                                        </div>
                                      </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="activityHeaders"></tr>
                                    <tr mat-row *matRowDef="let row; columns: activityHeaders;"></tr>
                                  </table>
                                }
                              </mat-card-content>
                            </mat-card>
